import { getFirestore, doc, collection, query, where, addDoc, getDoc, getDocs, updateDoc, setDoc, onSnapshot, deleteDoc, documentId } from "firebase/firestore"
let db = getFirestore()

let collectionName = "config"

// Raretés de carte (type) gérées par l'application, de la plus commune à la plus rare.
export const CARD_TYPES = ['common', 'uncommon', 'rare', 'mythic', 'legendary']

// Variantes (rareté visuelle) d'une carte.
export const CARD_VARIANTS = ['common', 'silver', 'golden', 'foil']

// Les légendaires ne sont jamais tirées autrement qu'en variante classique
// et il ne peut y en avoir qu'une seule par booster.
export const LEGENDARY_TYPE = 'legendary'
export const LEGENDARY_FORCED_VARIANT = 'common'
export const MAX_LEGENDARY_PER_BOOSTER = 1

function docToInstance(document) {
	let data = document.data()
	return data ? new Settings(
		document.id, 
		data.downgradeCost, 
		data.upgradeCost, 
		data.rarityPoints, 
		data.rarityCash, 
		data.collectionMultiplier, 
		data.extensionCompletionMultiplier,
		data.dailyBonus, 
		data.rarityDropRates,
		data.typeDropRates,
		data.welcomeBonus,
    data.raritySoul,
    data.soulPoints,
    data.dailyCardsCostMultiplicator,
    data.blackMarketMultiplicator,
	data.requiredBlackMarketBooster,
	data.tradeTicketPrice,
		data.tradeMaxGapPercent,
		data.treasureAccessPrice,
		data.treasureHintPrice,
		data.treasureHintMaxPurchases
	) : null
}

class Settings {
	constructor(id, downgradeCost, upgradeCost, rarityPoints, rarityCash, collectionMultiplier, extensionCompletionMultiplier, dailyBonus, rarityDropRates, typeDropRates, welcomeBonus, raritySoul, soulPoints, dailyCardsCostMultiplicator, blackMarketMultiplicator, requiredBlackMarketBooster, tradeTicketPrice, tradeMaxGapPercent, treasureAccessPrice, treasureHintPrice, treasureHintMaxPurchases) {
		this.id = id
		this.downgradeCost = downgradeCost !== undefined ? downgradeCost : 1
		this.upgradeCost = upgradeCost !== undefined ? upgradeCost : 5
		this.rarityPoints = rarityPoints || {
			common: 10,
			silver: 50,
			golden: 200,
			foil: 1000
		}
		this.rarityCash = rarityCash || {
			common: { common: 5, silver: 30, golden: 180, foil: 1000 },
			uncommon: { common: 10, silver: 60, golden: 360, foil: 2000 },
			rare: { common: 20, silver: 120, golden: 720, foil: 4000 },
			mythic: { common: 50, silver: 300, golden: 1800, foil: 10000 },
			legendary: { common: 0, silver: 0, golden: 0, foil: 0 }
		}
    this.raritySoul = raritySoul || {
      common: 1,
      uncommon: 3,
      rare: 5,
      mythic: 10,
      legendary: 0
    }
    this.soulPoints = soulPoints !== undefined ? soulPoints : 100
    this.dailyCardsCostMultiplicator = dailyCardsCostMultiplicator !== undefined ? dailyCardsCostMultiplicator : 200
    this.blackMarketMultiplicator = blackMarketMultiplicator !== undefined ? blackMarketMultiplicator : 1
    this.requiredBlackMarketBooster = requiredBlackMarketBooster !== undefined ? requiredBlackMarketBooster : 150
		this.tradeTicketPrice = tradeTicketPrice !== undefined ? tradeTicketPrice : 500
		this.tradeMaxGapPercent = tradeMaxGapPercent !== undefined ? tradeMaxGapPercent : 10
		this.treasureAccessPrice = treasureAccessPrice !== undefined ? treasureAccessPrice : 50
		this.treasureHintPrice = treasureHintPrice !== undefined ? treasureHintPrice : 50
		this.treasureHintMaxPurchases = treasureHintMaxPurchases !== undefined ? treasureHintMaxPurchases : 3

		// Migration old format (single object) to new format (double entry)
		if (this.rarityCash && typeof this.rarityCash.common === 'number') {
			const oldValues = { ...this.rarityCash }
			this.rarityCash = {}
			CARD_TYPES.forEach((type) => {
				this.rarityCash[type] = { ...oldValues }
			})
		}
		this.collectionMultiplier = collectionMultiplier !== undefined ? collectionMultiplier : 0.1
		this.extensionCompletionMultiplier = extensionCompletionMultiplier !== undefined ? extensionCompletionMultiplier : 0.25
		this.dailyBonus = dailyBonus !== undefined ? dailyBonus : 100
		this.welcomeBonus = welcomeBonus !== undefined ? welcomeBonus : 100
    this.rarityDropRates = rarityDropRates || {
      silver: 10,
      golden: 5,
      foil: 1
    }
		this.typeDropRates = typeDropRates || {
			common: 4,
			uncommon: 3,
			rare: 2,
			mythic: 1,
			legendary: 0
		}

		// Backfill : garantit qu'une raretés ajoutée après coup (ex: legendary)
		// existe bien dans les configs déjà enregistrées en base.
		this.normalizeRarities()
	}

	// Complète les structures indexées par rareté pour toutes les raretés connues.
	normalizeRarities() {
		if (!this.rarityCash || typeof this.rarityCash !== 'object') this.rarityCash = {}
		if (!this.raritySoul || typeof this.raritySoul !== 'object') this.raritySoul = {}
		if (!this.typeDropRates || typeof this.typeDropRates !== 'object') this.typeDropRates = {}

		CARD_TYPES.forEach((type) => {
			if (!this.rarityCash[type] || typeof this.rarityCash[type] !== 'object') {
				this.rarityCash[type] = {}
			}
			CARD_VARIANTS.forEach((variant) => {
				if (this.rarityCash[type][variant] === undefined || this.rarityCash[type][variant] === null) {
					this.rarityCash[type][variant] = 0
				}
			})

			if (this.raritySoul[type] === undefined || this.raritySoul[type] === null) {
				this.raritySoul[type] = 0
			}

			if (this.typeDropRates[type] === undefined || this.typeDropRates[type] === null) {
				this.typeDropRates[type] = 0
			}
		})

		CARD_VARIANTS.forEach((variant) => {
			if (variant === 'common') return
			if (this.rarityDropRates[variant] === undefined || this.rarityDropRates[variant] === null) {
				this.rarityDropRates[variant] = 0
			}
		})
		if (this.rarityDropRates.common === undefined || this.rarityDropRates.common === null) {
			const others = CARD_VARIANTS
				.filter(v => v !== 'common')
				.reduce((sum, v) => sum + (Number(this.rarityDropRates[v]) || 0), 0)
			this.rarityDropRates.common = Math.max(0, 100 - others)
		}
	}

	static async getAll() {
		const documents = await getDocs(collection(db, collectionName))
		return documents.docs.map(docToInstance)
	}

	static async getById(id) {
		const document = await getDoc(doc(db, collectionName, id))
		return docToInstance(document)
	}

	static async listenAll(callback) {
		return onSnapshot(collection(db, collectionName), (snapshot) => {
			const list = []
			snapshot.forEach((doc) => {
				list.push(docToInstance(doc))
			})
			callback(list)
		})
	}

	static async listenById(id, callback) {
		return onSnapshot(doc(db, collectionName, id), (snapshot) => {
			callback(docToInstance(snapshot))
		})
	}

	async save() {
		const new_doc = {
			downgradeCost: this.downgradeCost,
			upgradeCost: this.upgradeCost,
			rarityPoints: this.rarityPoints,
			rarityCash: this.rarityCash,
			collectionMultiplier: this.collectionMultiplier,
			extensionCompletionMultiplier: this.extensionCompletionMultiplier,
			dailyBonus: this.dailyBonus,
			welcomeBonus: this.welcomeBonus,
			rarityDropRates: this.rarityDropRates,
			typeDropRates: this.typeDropRates,
      raritySoul: this.raritySoul,
      soulPoints: this.soulPoints,
      dailyCardsCostMultiplicator: this.dailyCardsCostMultiplicator,
      blackMarketMultiplicator: this.blackMarketMultiplicator,
			requiredBlackMarketBooster: this.requiredBlackMarketBooster,
			tradeTicketPrice: this.tradeTicketPrice,
			tradeMaxGapPercent: this.tradeMaxGapPercent,
			treasureAccessPrice: this.treasureAccessPrice,
			treasureHintPrice: this.treasureHintPrice,
			treasureHintMaxPurchases: this.treasureHintMaxPurchases,
		}

		if (this.id) {
			await setDoc(doc(db, collectionName, this.id), new_doc)
		} else {
			this.id = "general"
			await setDoc(doc(db, collectionName, this.id), new_doc)
		}
		return true
	}

	async delete() {
		if (this.id) {
			await deleteDoc(doc(db, collectionName, this.id))
		}
		return true
	}
}

export default Settings
